import React, { Component } from "react";

class SearchPagination extends Component {
    constructor(props) {
        super(props);

        this.onClickPrevious = this.onClickPrevious.bind(this);
        this.onClickNext = this.onClickNext.bind(this);
    }

    onClickPrevious() {
        this.props.scrollToTop();
        this.props.onClickPrevious();
    }

    onClickNext() {
        this.props.scrollToTop();
        this.props.onClickNext();
    }

    render() {
        const totalPages = Math.ceil(this.props.totalCount / this.props.pageSize);
        const label = this.props.paginationIndicator
            .replace("{x}", this.props.pageIndex)
            .replace("{y}", totalPages);

        return (
            <div className="searchpage-pagination">
                {this.props.hasPrevious && (
                    <button
                        type="button"
                        className="button-hollow searchpage-pagination__prev"
                        onClick={this.onClickPrevious}
                        aria-label={`Gå tilbage til side ${this.props.pageIndex - 1} ud af ${totalPages}`}
                    >
                        {this.props.previousButtonLabel}
                    </button>
                )}
                {(this.props.hasPrevious || this.props.hasNext) && (
                    <span className="searchpage-pagination__label">{label}</span>
                )}
                {this.props.hasNext && (
                    <button
                        type="button"
                        className="button-hollow searchpage-pagination__next"
                        onClick={this.onClickNext}
                        aria-label={`Gå frem til side ${this.props.pageIndex + 1} ud af ${totalPages}`}
                    >
                        {this.props.nextButtonLabel}
                    </button>
                )}
            </div>
        );
    }
}

export default SearchPagination;
